module.exports = __webpack_public_path__ + "static/media/cctv2.c18820d6.png";